const formatDirectoryPath = (inputPath: string): string => {
  let formattedPath = inputPath;
  if (!formattedPath.startsWith('/')) {
    formattedPath = '/' + formattedPath;
  }
  if (!formattedPath.endsWith('/')) {
    formattedPath = formattedPath + '/';
  }
  return formattedPath;
};

export default formatDirectoryPath;
